import { MfaMethod } from '@/types/MfaMethod.ts';

interface LoginNeedMfaResponse extends Response {
	mfa: {
		methods: MfaMethod[];
		payload: string;
	};
}

interface LoginUserBlockedResponse extends Response {
	status: 0 | 1 | 2 | 3 | 4;
}

export type LoginUnauthorizedResponse = LoginNeedMfaResponse | LoginUserBlockedResponse;

export const isNeedMfa = (body: LoginUnauthorizedResponse): body is LoginNeedMfaResponse => 'mfa' in body;

export const isUserBlocked = (body: LoginUnauthorizedResponse): body is LoginUserBlockedResponse => 'status' in body;
